// Selected mailbox state for the EMAIL surface.
//
// The advisor picks one of:
//   * Their own mailbox (default — null)
//   * A registered shared mailbox UPN (e.g. insurance@stewardship.pro)
//
// The choice is saved to the advisor's ACCOUNT (2026-08-15), so it
// carries across reloads and across machines. Folder + message list
// components subscribe via the hook below; on change they re-fetch with
// the new mailbox parameter.
//
// Why a stored setting and not URL query state:
//   * Folder + message URLs are already path-heavy (/email/folders/<id>,
//     /email/messages/<id>). Adding ?mailbox=... to every link + every
//     navigation would be churny.
//   * Per-tab state would surprise advisors — switch mailbox in one
//     tab, open a household in another, the household's email
//     references show up scoped to the wrong mailbox.
//   * One stored setting gives a consistent global "I'm working in the
//     Insurance shared mailbox right now" mode, matching how Outlook
//     desktop treats shared mailboxes.

import { useUserSetting } from "../settings/user-settings-context";
import { EMAIL_SELECTED_MAILBOX } from "../settings/user-settings-registry";

export function useSelectedMailbox(): {
  selectedMailbox: string | null;
  setMailbox: (upn: string | null) => void;
} {
  // Which mailbox you're working in follows the ACCOUNT (2026-08-15), so
  // someone servicing a shared mailbox stays in it when they move
  // machines. The settings provider holds one copy for the whole app,
  // which also removed the cross-tab `storage` listener this hook used
  // to need: every consumer now reads the same context.
  const [selectedMailbox, setMailbox] = useUserSetting(EMAIL_SELECTED_MAILBOX);
  return { selectedMailbox, setMailbox };
}
